<script setup>
import { useAi } from '@/composables/useAi'

// pages/ai/history.vue — Module 22 (§29.3). Daftar percakapan milik user
// login sendiri (AIAssistantService::conversationsFor() di-scope
// user_id) — klik satu baris menampilkan riwayat pesannya lewat
// ChatWindow.vue (mode lanjutkan percakapan, bukan mulai baru).
definePage({
  meta: {
    layout: 'default',
    action: 'chat',
    subject: 'Ai',
  },
})

const { conversations, loading, fetchConversations } = useAi()

onMounted(fetchConversations)

const selected = ref(null)

const headers = [
  { title: 'Judul', key: 'title' },
  { title: 'Terakhir Diperbarui', key: 'updated_at' },
]
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Riwayat Percakapan AI
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Seluruh percakapan tersimpan penuh (BR-012)
    </p>

    <VRow>
      <VCol
        cols="12"
        :md="selected ? 5 : 12"
      >
        <VCard>
          <VDataTable
            :headers="headers"
            :items="conversations"
            :loading="loading"
            hide-default-footer
            @click:row="(e, { item }) => (selected = item.id)"
          >
            <template #item.title="{ item }">
              {{ item.title || `Percakapan #${item.id}` }}
            </template>
            <template #no-data>
              <div class="text-center py-10">
                <p class="text-medium-emphasis">
                  Belum ada percakapan.
                </p>
              </div>
            </template>
          </VDataTable>
        </VCard>
      </VCol>

      <VCol
        v-if="selected"
        cols="12"
        md="7"
      >
        <VCard>
          <VCardText class="pa-6">
            <ChatWindow :conversation-id="selected" />
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>
